import { type FooterRailId } from './footer-rail.constants';

// Every page navigation remounts the whole sidebar (layouts aren't persistent), so
// the collapsibles re-register from scratch via post-paint effects — leaving the
// first frame with empty membership, which paints the items uncollapsed before they
// fold back in (the flicker). This cache lets a remounted provider seed the last
// membership so the very first split already knows what collapses. Module-level to
// survive the remount; written only by the enabled (desktop) provider; never on the
// server (registration is DOM/effect-driven), so SSR/first paint start empty and
// match. Item visibility is stable within a session; re-registration only adds/updates
// ids (never removes), so an item that turned invisible while the provider was disabled
// can leave a phantom id — harmless, since it renders no tile and no More row and only
// nudges the split budget.
let cachedMembership: ReadonlyMap<FooterRailId, boolean> = new Map();

export const readMembershipCache = (): ReadonlyMap<FooterRailId, boolean> =>
  cachedMembership;

export const writeMembershipCache = (
  membership: ReadonlyMap<FooterRailId, boolean>
): void => {
  cachedMembership = membership;
};

/** Test-only: reset the cross-mount membership cache between cases. */
export const __resetMembershipCache = (): void => {
  cachedMembership = new Map();
};
